const preserveExistingInteractionResponsePresentation = ({ existingEvent, incomingEvent }) => {
  const normalizeInteractionType = (value) => {
    return String(value || '')
      .trim()
      .toLowerCase();
  };
  const existingInteractionType = normalizeInteractionType(existingEvent?.interactionType || existingEvent?.payload?.interactionType || existingEvent?.response?.interactionType || '');
  const incomingInteractionType = normalizeInteractionType(incomingEvent?.interactionType || incomingEvent?.payload?.interactionType || incomingEvent?.response?.interactionType || '');
  const nextEvent = {
    ...incomingEvent
  };

  if (Array.isArray(existingEvent?.lines) && existingEvent.lines.length > 0) {
    nextEvent.lines = existingEvent.lines;
  }

  if (Array.isArray(existingEvent?.segments) && existingEvent.segments.length > 0) {
    nextEvent.segments = existingEvent.segments;
  }

  if (existingInteractionType === 'permission_approval' && incomingInteractionType !== 'permission_approval') {
    nextEvent.interactionType = existingInteractionType;
  }

  if (!String(nextEvent?.className || '').trim() && String(existingEvent?.className || '').trim()) {
    nextEvent.className = existingEvent.className;
  }

  return nextEvent;
};

export default preserveExistingInteractionResponsePresentation;
